import { z } from 'zod';
const OidcStateSchema = z
    .object({
    initialUrl: z.string().min(1).url(),
})
    .strict();
export class OidcStateManager {
    static fromState(rawState) {
        return OidcStateSchema.parse(rawState);
    }
    static getInitialState() {
        return {
            initialUrl: window.location.href,
        };
    }
}
//# sourceMappingURL=state.js.map